import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Grid,
    useTheme,
    Flex,
} from '@chakra-ui/react';
import { MdClear } from 'react-icons/md';
import { FiSearch } from 'react-icons/fi';
import dayjs from 'dayjs';
import type { FuelConsumptionFilters } from '../types';

interface FilterFuelConsumptionProps {
    onFiltersChange: (filters: FuelConsumptionFilters) => void;
    isLoading?: boolean;
}

export const FilterFuelConsumption: React.FC<FilterFuelConsumptionProps> = ({
    onFiltersChange,
    isLoading = false,
}) => {
    const theme = useTheme();
    // Lacak data is complete only after the nightly sync, so default to yesterday.
    const defaultDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
    const [date, setDate] = useState<string>(defaultDate);

    const inputStyles = {
        size: 'sm' as const,
        borderRadius: 'lg',
        borderColor: 'gray.200',
        _hover: { borderColor: 'gray.300' },
        _focus: {
            borderColor: theme.colors.blue[400],
            boxShadow: `0 0 0 1px ${theme.colors.blue[400]}`,
        },
    };

    const handleApply = () => {
        if (date) onFiltersChange({ date });
    };

    const handleReset = () => {
        setDate(defaultDate);
        onFiltersChange({ date: defaultDate });
    };

    return (
        <Box
            bg="white"
            p={{ base: 4, md: 6 }}
            borderRadius="xl"
            boxShadow="sm"
            border="1px"
            borderColor="gray.100"
        >
            <VStack spacing={4} align="stretch">
                <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
                    <FormControl>
                        <FormLabel fontSize="sm" color="gray.600" mb={1}>Tanggal</FormLabel>
                        <Input
                            {...inputStyles}
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </FormControl>
                </Grid>

                <Flex
                    gap={2}
                    justify={{ base: 'stretch', md: 'flex-end' }}
                    direction={{ base: 'column', sm: 'row' }}
                >
                    <Button
                        leftIcon={<MdClear />}
                        onClick={handleReset}
                        isDisabled={isLoading}
                        size="sm"
                        variant="outline"
                        colorScheme="red"
                        borderRadius="lg"
                        flex={{ base: 1, sm: 'initial' }}
                    >
                        Reset
                    </Button>
                    <Button
                        leftIcon={<FiSearch />}
                        colorScheme="blue"
                        onClick={handleApply}
                        isLoading={isLoading}
                        isDisabled={!date}
                        size="sm"
                        borderRadius="lg"
                        flex={{ base: 1, sm: 'initial' }}
                    >
                        Terapkan
                    </Button>
                </Flex>
            </VStack>
        </Box>
    );
};
